// ella-collection-swatches.js
(function () {
  if (!document.addEventListener) return;

  // Helper: find closest ancestor matching selector
  function closest(el, selector) {
    while (el && el !== document) {
      if (el.matches && el.matches(selector)) return el;
      el = el.parentNode;
    }
    return null;
  }

  // Update one product card after a swatch click
function updateProductCard(productItem, variantData) {
  if (!productItem || !variantData) return;

  // 1) Update image: prefer .card-media img inside this product item
  var img = productItem.querySelector('.card-media img, .card-media__image, img');
  if (img && variantData.image) {
    if (img.hasAttribute('data-src')) {
      img.setAttribute('data-src', variantData.image);
      img.setAttribute('src', variantData.image);
      try { img.dispatchEvent(new Event('load')); } catch (e) {}
    } else {
      img.setAttribute('src', variantData.image);
    }
  }

  // 2) Update price HTML: find .card-price or similar inside this product card
  var priceEl = productItem.querySelector('.card-price, .product-card__price, .price, [data-product-price]');
  if (priceEl && variantData.priceHtml) {
    priceEl.innerHTML = variantData.priceHtml;
  }

  // 2.5) IMPORTANT: update Add to Cart variant ID
  // This makes sure "Add to Cart" uses the selected variant (Black/White)
  if (variantData.variantId) {
    var idInputs = productItem.querySelectorAll('input[name="id"]');
    idInputs.forEach(function (input) {
      input.value = variantData.variantId;
    });
  }

  // 3) Update card links (image + title) to include ?variant=<id>
  var mediaLink = productItem.querySelector('.card-link');
  if (mediaLink && variantData.variantId) {
    var base = mediaLink.getAttribute('href').split('?')[0];
    mediaLink.setAttribute('href', base + '?variant=' + variantData.variantId);
  }

  var titleLink = productItem.querySelector('.card-title');
  if (titleLink && variantData.variantId) {
    var baseT = titleLink.getAttribute('href').split('?')[0];
    titleLink.setAttribute('href', baseT + '?variant=' + variantData.variantId);
  }

  // 4) Update visual title suffix (e.g. " - White")
  var suffixSpan = productItem.querySelector('[data-change-title]');
  if (suffixSpan) {
    if (variantData.variantTitle && variantData.variantTitle.trim() !== '') {
      suffixSpan.textContent = ' - ' + variantData.variantTitle;
    } else {
      suffixSpan.textContent = '';
    }
  }

  // 5) Store current variant ID on the product card
  productItem.setAttribute('data-current-variant-id', variantData.variantId || '');
}

  // Handles click events on any element that has data-variant-id attribute inside a product item
  function onDocumentClick(e) {
    var swatchEl = closest(e.target, '[data-variant-id]');
    if (!swatchEl) return;

    // Find the containing product item (root .product-item)
    var productItem = closest(swatchEl, '.product-item, [data-product-id]');
    if (!productItem) return;

    var productId = productItem.getAttribute('data-product-id');

    // Gather variant info from the clicked element (data attributes expected)
    var variantId = swatchEl.getAttribute('data-variant-id') || swatchEl.dataset.variantId;
    var variantTitle = swatchEl.getAttribute('data-variant-title') || swatchEl.dataset.variantTitle || swatchEl.textContent.trim();
    var variantImage = swatchEl.getAttribute('data-variant-image') || swatchEl.dataset.variantImage || swatchEl.getAttribute('data-image') || null;
    var variantPriceHtml = swatchEl.getAttribute('data-variant-price-html') || swatchEl.dataset.variantPriceHtml || null;

    // If variantImage is a relative URL (like //cdn...), make sure it's absolute or leave as-is
    var variantData = {
      variantId: variantId,
      variantTitle: variantTitle,
      image: variantImage,
      priceHtml: variantPriceHtml
    };

    // Update current product card
    updateProductCard(productItem, variantData);

    // Manage active state for swatches in the same swatch container
    var swatchContainer = closest(swatchEl, '.product-swatch, .product-card__swatches, [data-swatch-container]') || swatchEl.parentNode;
    if (swatchContainer) {
      var siblings = swatchContainer.querySelectorAll('[data-variant-id]');
      siblings.forEach(function (s) { s.classList.remove('is-active'); });
    }
    swatchEl.classList.add('is-active');

    // Prevent clicks on swatches from navigating if they are inside an anchor
    e.preventDefault();
  }

  // Init on DOM ready
  document.addEventListener('DOMContentLoaded', function () {
    document.addEventListener('click', onDocumentClick, false);

    // If the page is server-rendering a default variant selection per product (rare),
    // we leave it as-is. We only alter when the user clicks a swatch.
  });

})();